import React from 'react'
import PropTypes from 'prop-types'
import { Typography, Input, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    root: {
        paddingBottom: theme.spacing(1)
    },
    suffixInput: {
        border: 'none',
        backgroundColor: 'transparent',
        color: theme.palette.text.primary,
        fontSize: theme.typography.h4.fontSize
    }
}))

const BlockTitle = ({ title, isEditing, setEditing, suffix, setSuffix }) => {
    const classes = useStyles()
    return (
        <Grid
            container
            spacing={1}
            alignItems="center"
            wrap="nowrap"
            className={classes.root}
        >
            <Grid item>
                <Typography noWrap variant="h4" color="textPrimary">
                    {title}
                </Typography>
            </Grid>
            <Grid item>
                {isEditing ? (
                    <Input
                        className={classes.suffixInput}
                        defaultValue={suffix}
                        autoFocus
                        onChange={(event) => setSuffix(event.target.value)}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                                e.currentTarget.blur()
                            }
                        }}
                        onFocus={(event) => {
                            event.stopPropagation()
                        }}
                        onBlur={(event) => {
                            setEditing(event)
                        }}
                        onClick={(event) => {
                            event.stopPropagation()
                        }}
                    />
                ) : setSuffix ? (
                    <Grid container spacing={1} wrap="nowrap">
                        <Grid item>
                            <Typography variant={'h4'} color={'textPrimary'}>
                                {suffix}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant={'h4'} color={'textSecondary'}>
                                <i
                                    onClick={(event) => setEditing(event)}
                                    onFocus={(event) => event.stopPropagation()}
                                    className={'far fa-edit'}
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                ) : null}
            </Grid>
        </Grid>
    )
}

/*<input
                    className={classes.suffixInput}
                    defaultValue={suffix}
                    autoFocus={true}
                    onChange={(event) => setSuffix(event.target.value)}
                    onKeyDown={(e) => {
                        if (e.keyCode === 13) {
                            e.currentTarget.blur()
                        }
                    }}
                    onFocus={(event) => {
                        event.stopPropagation()
                    }}
                    onBlur={(event) => {
                        setEditing(event)
                    }}
                    onClick={(event) => {
                        event.stopPropagation()
                    }}
                />*/

BlockTitle.propTypes = {
    suffix: PropTypes.string,
    setSuffix: PropTypes.func,
    isEditing: PropTypes.bool,
    setEditing: PropTypes.func
}

export default BlockTitle
